module.exports = __webpack_public_path__ + "static/image/course-related.svg?2954e05b103da305e48873893753e188";